import { useQuery } from 'react-query';

import { useApi } from '@/lib/api';
import { computeGeometryAreaIdOrStageId } from '@/lib/api/queries/utils';
import { useLocale } from '@/lib/contexts';

import { TypePeriod } from '@/components/activity-reports/period-selector';

interface ActivityReportNewbuildsUnitsTableProps {
  workspaceId: string;
  geometry?: string;
  areaId?: string;
  filters?: Record<string, any>;
  lastPeriodIncludes?: string;
  period?: TypePeriod[];
  enabled?: boolean;
}

export function useArSoldNewbuildsUnitsTable({
  workspaceId,
  filters,
  geometry,
  areaId,
  period,
  lastPeriodIncludes,
  enabled,
}: ActivityReportNewbuildsUnitsTableProps) {
  const { api } = useApi();
  const { locale } = useLocale();

  return useQuery(
    [
      'activity-reports-sold-newbuilds-units-table',
      workspaceId,
      geometry,
      filters,
      areaId,
      locale,
      period,
      lastPeriodIncludes,
    ],
    async () =>
      typeof workspaceId === 'string'
        ? api.geodata.chartSources.activityReportsSoldNewbuildsUnitsTable(
            workspaceId,
            {
              ...filters,
              ...computeGeometryAreaIdOrStageId(geometry, areaId),
              period: period,
              last_period_includes: lastPeriodIncludes,
            }
          )
        : undefined,
    {
      enabled:
        enabled &&
        !!workspaceId &&
        !!period &&
        !!computeGeometryAreaIdOrStageId(geometry, areaId),
      //These are mandatory params by the endpoint
    }
  );
}
